import call from "@brainspore/celadon-base/service/http";
import constants from "./academicConstants";
// import { router } from "../../../../main";
export default {
  state: {
    academics: [],
    academic: {},
  },
  mutations: {
    SET_ACADEMICS: (state, payload) => {
      state.academics = payload;
    },
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
    RESET_ACADEMIC: (state) => {
      state.academic = {};
    },
  },
  getters: {
    academicsGetters: (state) => (value) => state[value],
  },
  actions: {
    getacademics: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.academics(data))
        .then((res) => {
          commit("MUTATE", { state: "academic", data: res.data.data[0] });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    resetAcademic: ({ commit }) => {
      commit("SET_ACADEMIC", { state: "academic" });
    },
    editacademics: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", constants.editacademics, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to academics
          Event.$emit("backToList");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    submitacademics: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.postacademics, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to academics
          Event.$emit("backToList");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    deleteacademics: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", constants.deleteacademics(data), data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
